<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>

        <translation-billing-form
            id="translation-billing-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource"
            :readonly="true"
        />
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import TranslationBillingForm from "./TranslationBillingForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import { handleGeneralXhrError } from "../../helpers";

export default {
    components: {
        XPage,
        XBackButton,
        TranslationBillingForm,
        XTable,
    },
    computed: {
        pageTitle() {
            let title = ["Lihat Billing"];

            if (this.resource) {
                title.push(`#${this.resource.display_name}`);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/translation-billings/${this.$route.params.id}`)
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
};
</script>
